import angular from 'angular';

import RwSubordinatesTableComponent from './rw-subordinates-table-component';

export default angular
  .module('rw-subordinates-table', [])
  .component('rwSubordinatesTable', new RwSubordinatesTableComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/components/rw-subordinates-table/rw-subordinates-table-module.js